import React, { useEffect } from "react";
import Header from "components/header/Header";
import Footer from "components/footer/Footer";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import Section from "components/section/Section";
import Avatar from "components/avatar/Avatar";
import Sidebar from "components/sidebar/Sidebar";
import dumy_dog from "../../../assets/images/dumy_dog.png";
import "./Home.css";
import UserAuth from "components/AuthGaurd/UserAuth";
import { useSelector, useDispatch } from "react-redux";
import { AppDispatch } from "redux-store/store";
import { getUserPets } from "redux-store/pets/pet.slice";
import { pet } from "redux-store/pets/pet.selector";
import { Link, useNavigate } from "react-router-dom";
import { user } from "redux-store/user/user.selectors";
import { getLoggedInUser } from "redux-store/user/user.slice";

const Home = () => {
  const dispatch = useDispatch<AppDispatch>();
  const naviagte = useNavigate();
  const pets = useSelector(pet);
  const logedInUser = useSelector(user);

  useEffect(() => {
    dispatch(getLoggedInUser());
  }, []);

  useEffect(() => {
    dispatch(getUserPets(logedInUser?._id));
  }, [getLoggedInUser]);

  return (
    <UserAuth>
      <div className="oc-home">
        <Header admin={false} />

        <Container fluid className="px-0 oc-home-wrapper">
          <Row>
            <Col xs={12} sm={12} lg={8}>
              <Section title="Welcome">
                <Card className="oc-card shadow-sm border-0 rounded-5 tw-m-5 sm:tw-m-12 lg:tw-m-5 mb-5">
                  <Card.Body className="tw-p-2 tw-py-5 ">
                    <div className="tw-flex tw-flex-col tw-items-start lg:tw-items-start lg:tw-justify-start tw-m-4 tw-gap-2">
                      <h2 className="tw-text-2xl tw-font-[900] lg:tw-text-left md:tw-text-left tw-text-center sm:tw-mb-4">
                        Lab Test Results
                      </h2>
                      <span className="tw-mb-6 tw-text-md tw-text-gray-400 lg:tw-text-left md:tw-text-left">
                        Ready to get your results? First you’ll need to activate your test kit. Click the button below
                        to get Started.
                      </span>
                      <Link
                        to={"/user/activate/no"}
                        className="tw-text-white tw-text-[16px] md:tw-text-[20px] tw-border-2 tw-px-[36px] sm:tw-px-[40px] tw-py-2 lg:tw-py-3 tw-rounded-[10px] tw-border-reddishOrange tw-bg-reddishOrange hover:tw-text-white hover:tw-bg-darkRed hover:tw-border-darkRed tw-cursor-pointer"
                      >
                        Activate
                      </Link>
                    </div>
                  </Card.Body>
                </Card>
                <Card className="oc-card shadow-sm  border-0 rounded-5 tw-m-5 sm:tw-m-12 lg:tw-m-5 mb-5">
                  <Card.Body className="p-md-5 ">
                    <Row className="justify-content-between align-items-center mb-5">
                      <Col xs="auto">
                        <h2 className="tw-text-[24px] tw-font-[900]">My Pets</h2>
                      </Col>
                      <Col xs="auto">
                        <Card.Link
                          className={`${
                            pets?.length !== 0 ? "tw-decoration-gray-none" : "tw-hidden tw-decoration-gray-none"
                          }`}
                        >
                          <Link
                            to="/user/pets"
                            className={`${
                              pets?.length !== 0 ? "tw-decoration-gray-none" : "tw-hidden tw-decoration-gray-none"
                            }`}
                          >
                            View All
                          </Link>
                        </Card.Link>
                      </Col>
                    </Row>

                    {pets?.length !== 0 ? (
                      <Row className="justify-content-between align-items-center">
                        <Col xs="auto">
                          <Avatar
                            name={pets && pets[0]?.petName !== "" ? pets[0]?.petName : "None"}
                            src={pets && pets[0]?.photo !== "" ? pets[0]?.photo : dumy_dog}
                          />
                        </Col>
                        <Col xs="auto">
                          <Button
                            variant="outline-light"
                            className="tw-flex tw-items-center tw-mt-4 sm:tw-mt-0 tw-p-3 tw-gap-2 tw-justify-center tw-w-[116px] tw-h-[48px] tw-bg-[#FF7B6D] tw-rounded-xl tw-text-white hover:tw-bg-[#FF7B6D] hover:tw-text-emerald-50"
                            onClick={() => {
                              naviagte(`/user/pets/pet-details/${pets && pets[0]._id}`);
                            }}
                          >
                            Pet Details
                          </Button>
                        </Col>
                      </Row>
                    ) : (
                      <div className=" tw-flex tw-justify-between">
                        <span className="tw-text-md tw-text-gray-400 tw-text-center tw-self-center">No Pets Found</span>
                        <Button
                          variant="outline-light"
                          className="tw-flex tw-items-center tw-mt-4 sm:tw-mt-0 tw-p-3 tw-gap-2 tw-justify-center tw-w-[116px] tw-h-[48px] tw-bg-[#FF7B6D] tw-rounded-xl tw-text-white hover:tw-bg-[#FF7B6D] hover:tw-text-emerald-50"
                          onClick={() => {
                            naviagte(`/user/pets/edit-pet-details/add`);
                          }}
                        >
                          Add Pet
                        </Button>
                      </div>
                    )}
                  </Card.Body>
                </Card>
              </Section>
            </Col>
            <Col sm={0} lg={4} className="tw-hidden min-[992px]:tw-block">
              <Sidebar />
            </Col>
          </Row>
        </Container>
        <Row className="tw-block tw-mx-0">
          <Footer />
        </Row>
      </div>
    </UserAuth>
  );
};

export default Home;
function dispatch(arg0: any) {
  throw new Error("Function not implemented.");
}
